export function tabsCreate() {
  $(".my-tabs").click(function(){
      const tab_group = $(this).data('rel')
      const tab_content = $(this).data('content')
      const tab_stuff = $(this).data('parcel')

      $(".my-tabs[data-rel='"+ tab_group +"']").removeClass("active")
      $(this).addClass("active")
      $(".my-tabs[data-content='"+ tab_content  +"']").addClass("active")

      $(".my-tabs-content[data-rel='"+ tab_group +"']").hide()
      $(".my-tabs-content[data-stuff='"+ tab_stuff +"']").show()
      $("#"  + $(this).attr("data-content")).fadeIn();
  });
}

export function tabsInit() {
  $(".my-tabs-content").hide()
  $(".my-tabs.active").each(function(){
      const tab_ativa = $(this).attr("data-content")
      $("#" + tab_ativa).show()
  });

  $(".my-tabs-content.active.parcel").show()

}
